import api from './api';

export const scientistService = {
  // Get scientist dashboard summary
  async getDashboardSummary() {
    try {
      const response = await api.get('/scientist/dashboard/summary');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch dashboard summary');
    }
  },

  // Get assigned trials for the current scientist
  async getAssignedTrials() {
    try {
      const response = await api.get('/scientist/assigned-trials');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch assigned trials');
    }
  },

  // Get recent activities for scientist
  async getRecentActivities() {
    try {
      const response = await api.get('/scientist/recent-activities');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch recent activities');
    }
  },

  // Get trial analytics and statistics
  async getTrialAnalytics(trialId) {
    try {
      const response = await api.get(`/scientist/trials/${trialId}/analytics`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial analytics');
    }
  },

  // Get location performance data
  async getLocationPerformance(locationId) {
    try {
      const response = await api.get(`/scientist/locations/${locationId}/performance`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch location performance');
    }
  },

  // Get data quality metrics
  async getDataQualityMetrics() {
    try {
      const response = await api.get('/scientist/data-quality-metrics');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch data quality metrics');
    }
  },

  // Get trial progress reports
  async getTrialProgressReports(trialId) {
    try {
      const response = await api.get(`/scientist/trials/${trialId}/progress-reports`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial progress reports');
    }
  },

  // Update trial parameters
  async updateTrialParameters(trialId, parameters) {
    try {
      const response = await api.put(`/scientist/trials/${trialId}/parameters`, parameters);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update trial parameters');
    }
  },

  // Get plot officer performance
  async getPlotOfficerPerformance() {
    try {
      const response = await api.get('/scientist/plot-officer-performance');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch plot officer performance');
    }
  },

  // Export trial data
  async exportTrialData(trialId, format = 'excel') {
    try {
      const response = await api.get(`/scientist/trials/${trialId}/export/${format}`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to export trial data');
    }
  }
};
